<div class="setup-totp-container">
  <div class="setup-totp-card">
    <div class="header">
      <figure class="logo-wrapper">
        <img class="logo" [src]="loginState.displayLogo$ | async" alt="Login Logo" />
      </figure>
    </div>

    <ng-container>
      <ninety-totp
        [mfaTotpEnabled]="(vm | async)?.mfaTotpState"
        [companyEnforcedMfa]="true"
        [workflow]="MfaTotpVerificationFlow.LOGIN_TOTP_SETUP"></ninety-totp>
    </ng-container>

    <span class="back-button-action">
      <button
        secondary
        outlined
        class="ninety-cta-secondary back-button"
        id="back-button"
        data-product="login_setup-totp-back-button"
        data-cy="login_setup-totp-back-button"
        aria-label="Back to previous step"
        (click)="onBack()">
        Back
      </button>
    </span>
  </div>
</div>
